import React, { useState, useEffect } from 'react';
import { updatePerfiles } from '../../../api/usuarios';
import { Button, TextField, Box, CircularProgress } from '@mui/material';

export const EditPerfil = React.memo(({ usuario, onClose }: any) => {
  const [formData, setFormData] = useState(usuario);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    Pe_Nombre: '',
    Pe_Describ: '',
    
  });

  useEffect(() => {
    setFormData(usuario);
  }, [usuario]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let tempErrors = { Pe_Nombre: '', Pe_Describ: '' };
    if (!formData.Pe_Nombre) tempErrors.Pe_Nombre = 'El nombre es requerido';
    if (!formData.Pe_Describ) tempErrors.Pe_Describ = 'La descripción es requerida';
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === '');
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    await updatePerfiles(formData.Pe_Id, formData);
    setLoading(false);
    onClose();
  };

  return (
    <div>
      <form>
        <TextField label='Nombre' name='Pe_Nombre' value={formData.Pe_Nombre} onChange={handleChange} fullWidth required sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size='small' error={!!errors.Pe_Nombre} helperText={errors.Pe_Nombre} />        
        <TextField label='Descripción' name='Pe_Describ' value={formData.Pe_Describ} onChange={handleChange} fullWidth required sx={{ marginBottom: '0.8rem' }} size='small' error={!!errors.Pe_Describ} helperText={errors.Pe_Describ} />
        <Box display='flex' justifyContent='space-between'>
          <Button onClick={handleSubmit} variant='outlined' size='small' disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Actualizar'}
          </Button>
          <Button onClick={onClose} variant='outlined' color='error' size='small'>
            Cancelar
          </Button>
        </Box>
      </form>
    </div>
  );
});


